var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#patternLV)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patternLV",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8917_2528",
    transform: "translate(-0.5) scale(0.00628931)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8917_2528",
    width: 318,
    height: 159,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT4AAACfCAIAAADvbSKYAAAEbklEQVR4Ae3dsW2sABBFUTrYHsgogEYdWSvRjtvCTbzkSudrYzQ6w2V+5uM5bz8CBHICR25iAxMg8Jy3dP2ng0BSQLrJtTk7BKQrXQJJAekm1+bmEJCudAkkBaSbXJubQ0C60iWQFJBucm1uDgHpSpdAUkC6ybW5OQSkK10CSQHpJtfm5hCQrnQJJAWkm1ybm0NAutIlkBSQbnJtbg4B6UqXQFJAusm1uTkEpCtdAkkB6SbX5uYQkK50CSQFpJtcm5tDQLrSJZAUkG5ybW4OAelKl0BSQLrJtbk5BKQrXQJJAekm1+bmEJCudAkkBaSbXJubQ0C60iWQFJBucm1uDgHpSpdAUkC6ybW5OQSkK10CSQHpJtfm5hCQrnQJJAWkm1ybm0NAutIlkBSQbnJtbg4B6UqXQFJAusm1uTkEpCtdAkkB6SbX5uYQkK50CSQFpJtcm5tDQLrSJZAUkG5ybW4OAelKl0BSQLrJtbk5BKQrXQJJAekm1+bmEJCudAkkBaSbXJubQ0C60iWQFJBucm1uDgHpSpdAUkC6ybW5OQSkK10CSQHpJtfm5hA4vp/LjwCBnMDx9/PrR4BATuB4/SNAICgg3eDSjEzgfaXrLSCQFJBucm2GJiBd7wCBpIB0k2szNAHpegcIJAWkm1yboQlI1ztAICkg3eTaDE1Aut4BAkkB6SbXZmgC0vUOEEgKSDe5NkMTkK53gEBSQLrJtRmagHS9AwSSAtJNrs3QBKTrHSCQFJBucm2GJiBd7wCBpIB0k2szNAHpegcIJAWkm1yboQlI1ztAICkg3eTaDE1Aut4BAkkB6SbXZmgC0vUOEEgKSDe5NkMTkK53gEBSwN/X9eeFCSQF/FX7K/fnzA1M4Pu5jue8/QgQyAlI15eLQFJAusm15U6EgecC0pUugaSAdJNrm3/CPTAnIF3pEkgKSDe5ttyJMPBcQLrSJZAUkG5ybfNPuAfmBKQrXQJJAekm15Y7EQaeC0hXugSSAtJNrm3+CffAnIB0pUsgKSDd5NpyJ8LAcwHpSpdAUkC6ybXNP+EemBOQrnQJJAWkm1xb7kQYeC4gXekSSApIN7m2+SfcA3MC0pUugaSAdJNry50IA88FpCtdAkkB6SbXNv+Ee2BOQLrSJZAUkG5ybbkTYeC5gHSlSyApIN3k2uafcA/MCUhXugSSAtJNri13Igw8F5CudAkkBaSbXNv8E+6BOQHpSpdAUkC6ybXlToSB5wLSlS6BpIB0k2ubf8I9MCcgXekSSApIN7m23Ikw8FxAutIlkBSQbnJt80+4B+YEpCtdAkkB6SbXljsRBp4LSFe6BJIC0k2ubf4J98CcgHSlSyApIN3k2nInwsBzAelKl0BSQLrJtc0/4R6YE5CudAkkBaSbXFvuRBh4LiBd6RJICkg3ubb5J9wDcwLSlS6BpIB0k2vLnQgDzwWkK10CSQHpJtc2/4R7YE5AutIlkBSQbnJtuRNh4LmAdKVLICkg3eTa5p9wD8wJSFe6BJIC/9Xny8el/6sDAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLv);
export default __webpack_public_path__ + "static/media/LV.9d3dcafaef1ffd573b8d0493f93a57b1.svg";
export { ForwardRef as ReactComponent };